import { Component, h } from 'preact';
import linkState from 'linkstate';

import { Inquiry } from '../../../../../types/inquiries';
import { HopplerModalizer } from '../../common/hoppler-modalizer.component';
import { FormattedNumberInput } from '../../common/formatted-number-input.component';
import { inquiryService } from '../../../../utils/inquiry.service';
import { ReqState } from '../../../../../types';


interface InqEditInvoiceNumberModalProps {
  inquiry: Inquiry;
  onClose: () => void;
  onInvoiceUpdateSuccess: () => void;
}

interface InqEditInvoiceNumberModalState {
  invoiceNumber?: string;
  reqState?: ReqState;
}

export class InqEditInvoiceNumberModal extends Component<InqEditInvoiceNumberModalProps, InqEditInvoiceNumberModalState> {
  constructor(props: InqEditInvoiceNumberModalProps) {
    super(props);

    this.state = {
      invoiceNumber: props.inquiry.invoiceNumber
    };
  }

  async onSubmit(event: Event) {
    event.preventDefault();

    const inquiry = this.props.inquiry;

    try {
      this.setState({ reqState: ReqState.IN_PROGRESS });
      const response = await inquiryService.updateInvoiceNumber(inquiry.inquiryCode, this.state.invoiceNumber);
      this.setState({ reqState: ReqState.SUCCESS });

      this.props.onClose();
      this.props.onInvoiceUpdateSuccess();
    } catch (err) {
      this.setState({ reqState: ReqState.FAILED });
      console.error(err);
    }
  }

  isSubmitButtonEnabled() {
    return !!this.state.invoiceNumber;
  }

  getSubmitButton() {
    if (this.state.reqState === ReqState.IN_PROGRESS) {
      return (
        <button type="submit" className="btn btn-secondary" disabled>
          <i className="fas fa-cog fa-spin" /> Submitting...
        </button>
      )
    } else {
      return (
        <button type="submit" className="btn btn-secondary">
          Submit
        </button>
      );
    }
  }

  render(props: InqEditInvoiceNumberModalProps, state: InqEditInvoiceNumberModalState) {
    return (
      <HopplerModalizer onClose={ () => null}>
        <div className="hi-edcolamtmod">
          <div className="hi-edcolamtmod__title-bar">
            <span className="hi-edcolamtmod__title-label">Input Invoice No.</span>
            <button className="btn btn-link hi-edcolamtmod__title-close" onClick={ props.onClose }>
              <i className="fas fa-times" /> close
            </button>
          </div>

          <div className="hi-edcolamtmod__body">
            <form className="hi-edcolamtmod__content" onSubmit={ evt => this.onSubmit(evt) }>
              <div className="hi-input-group">
                <label className="hi-input-group__label">
                  Invoice No.
                </label>
                <input type="text" className="form-control" value={ state.invoiceNumber }
                  placeholder="00000000"
                  onChange={ linkState(this, 'invoiceNumber') } />
              </div>

              <div className="text-center">
                { this.getSubmitButton() }
              </div>
            </form>
          </div>
        </div>
      </HopplerModalizer>
    );
  }
}
